// @flow
import styled from 'styled-components'
import { Layout } from 'antd'
const { Content } = Layout

export const StyledContent = styled(Content)`
  background: #fff;
  min-height: 280px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  
  & h3 {
    font-size: 15px;
    letter-spacing: 0.25px;
    margin-bottom: 16px;
  }
  & .ant-list-split .ant-list-item { 
    margin: 0;
    padding: 0;
    height: 30px;
    color: #fff;
    font-weight: 100;
    
    &.active-item { 
      font-weight: 900;
    }
    .anticon { 
      color: #fff;
    }
  }
  .ant-list-empty-text { 
    color: #fff;
  }
`

export const StyledGroup = styled.div`
  .ant-list {
    margin-top: 10px;
  }
  .ant-list-item-action { 
    margin-bottom: 0;
  }
  .ant-btn { 
    margin-left: 5px;
  }
`



// WEBPACK FOOTER //
// ./src/components/list-targets/style.js